import { useMemo } from "react";
import { useQuery } from "react-query";
import { getPracticeDashboardWorkspaces } from "apps/project-iq/api";
import { IProjectIQWorkspace } from "models/IProjectIQWorkspace";

export const PRACTICE_DASHBOARD_WORKSPACES_QUERY_KEY =
  "practiceDashboardWorkspaces";

export interface IUsePracticeDashboardWorkspacesParams {
  isEnabled: boolean;
}

export interface IUsePracticeDashboardWorkspacesResult {
  workspaces: IProjectIQWorkspace[];
  isLoading: boolean;
  isRefreshing: boolean;
  isError: boolean;
}

export const usePracticeDashboardWorkspaces = ({
  isEnabled,
}: IUsePracticeDashboardWorkspacesParams): IUsePracticeDashboardWorkspacesResult => {
  const { data, isLoading, isFetching, isError } = useQuery<
    IProjectIQWorkspace[],
    Error
  >({
    queryKey: [PRACTICE_DASHBOARD_WORKSPACES_QUERY_KEY],
    queryFn: () => getPracticeDashboardWorkspaces(),
    enabled: isEnabled,
    refetchOnWindowFocus: false,
  });

  const workspaces = useMemo(() => data ?? [], [data]);

  return {
    workspaces,
    isLoading,
    isRefreshing: isFetching && !isLoading,
    isError,
  };
};
